"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GeetestCaptcha_1 = require("./GeetestCaptcha");
var Recaptcha_1 = require("./Recaptcha");
var types_1 = require("./types");
var Captcha = function (props) {
    var captchaType = props.captchaType, recaptcha = props.recaptcha, geetest = props.geetest;
    if (captchaType === types_1.CaptchaType.Recaptcha && !recaptcha) {
        throw new Error('recaptcha should be passed as a prop');
    }
    else if (captchaType === types_1.CaptchaType.Geetest && !geetest) {
        throw new Error('geetest should be passed as a prop');
    }
    return captchaType === types_1.CaptchaType.Recaptcha ?
        React.createElement(Recaptcha_1.default, __assign({}, recaptcha))
        :
            React.createElement(GeetestCaptcha_1.default, __assign({}, geetest));
};
Captcha.displayName = 'Captcha';
exports.default = Captcha;
//# sourceMappingURL=Captcha.js.map